export const langTH = {
  trueIdrec:"True ID ผู้แนะนำ",
  brandLabel: "ยี่ห้อ",
  bathMonth: "บาท/เดือน ",
  payVat: "(ราคาขายรวมภาษีมูลค่าเพิ่ม)",
  orderPrduct: "สั่งจองสินค้า",
  conditionPrice: " *ราคาที่แสดงเป็นราคาต่อเดือนที่รวมภาษีมูลค่าเพิ่ม 7% แล้ว",
  dataProfile: "ข้อมูลส่วนตัว",
  logout: "ออกจากระบบ",
  editProdile: "แก้ไขรายละเอียด",
  approve: "อนุมัติ",
  // waitconfirm: "รอยืนยัน",
  waitconfirm: "รอการตรวจสอบ",
  reject: "ไม่อนุมัติ",
  waitSend: "รอส่งของ",
  send: "ส่งของแล้ว",
  waitapprove: "รออนุมัติ",
  pending: "รอดำเนินการ",
  color: "สี",
  deleteOrder: "ลบรายการ",
  pricePermonth: "ราคา/เดือน",
  priceVat: "(รวมภาษีมูลค่าเพิ่ม 7%)",
  contact: "ระยะสัญญา",
  allPrice: "ราคารวม",
  allContact: "ทั้งระยะสัญญา",
  addrDelivery: "ที่อยู่จัดส่งสินค้า",
  number: "หมายเลข",
  IRservice: " บริการเสริม (IR/IDD)",
  editOrder: "กรุณาระบุข้อมูลให้ครบถ้วน",
  orderProduct: "สั่งซื้อ",
  cart: "ตะกร้าสินค้า",
  backToHome: "กลับหน้าหลัก",
  howToOrder: "วิธีการสั่งซื้อ",
  orderList: "รายการจองสิทธิ",
  detail: "รายละเอียด",
  status: "สถานะ",
  confirmOrder: "ยืนยันการสั่งซื้อ",
  addrBill: "ที่อยู่จัดส่งใบแจ้งค่าบริการ",
  telNumberService: "หมายเลขโทรศัพท์ และบริการเสริม",
  newNumber: "ประสงค์ใช้หมายเลขโทรศัพท์ใหม่",
  existNumber: "ประสงค์ใช้หมายเลขโทรศัพท์เดิม",
  verifyNumber: "ตรวจสอบหมายเลขโทรศัพท์",
  validateRequire: "กรุณากรอกข้อมูล",
  validateCheck: "กรุณากดปุ่มตรวจสอบก่อนทำการบันทึก",
  verify: "ตรวจสอบ",
  IR: "ประสงค์ใช้บริการข้ามประเทศ (IR) และ",
  IDD: "บริการโทรทางไกลระหว่างประเทศ (IDD)",
  ok: "ตกลง",
  cancel: "ยกเลิก",
  save: "บันทึก",
  login: "เข้าสู่ระบบ/ลงทะเบียน",
  validateProfile: "กรุณาใส่ข้อมูลส่วนตัวให้ครบถ้วน",
  validateQuota: "คุณได้ใช้สิทธิ์ครบจำนวนโควต้าแล้ว",

  formEmail: "อีเมล์",
  formTel: "เบอร์โทรติดต่อ",
  formPosition: "ตำแหน่ง",
  formCompany: "หน่วยงานต้นสังกัด/บริษัท",
  formAddress_delivery: "ที่อยู่จัดส่งสินค้า",
  formTitle: "คำนำหน้า",
  formFName: "ชื่อจริง",
  formLName: "นามสกุล",
  formIDCard: "เลขที่บัตรประชาชน",
  formexpireIDCard: "วันหมดอายุบัตร",
  formDOB: "วันเกิด",
  formAddrIDCard: "ที่อยุ่ตามบัตรประชาชน",
  formBuilding: "หมู่บ้าน/อาคาร",
  formFloors: "ชั้น",
  formMoo: "หมู่",
  formSoi: "ตรอก/ซอย",
  formStreet: "ถนน",
  formProvince: "จังหวัด",
  formAmpur: "อำเภอ/เขต",
  formTumbon: "ตำบล/แขวง",
  formZip: "รหัสไปรษณีย์",
  formSelAddress_company: "เลือกหน่วยงานต้นสังกัด/บริษัท",
  formSelAddress_delivery: "เลือกที่อยู่จัดส่งสินค้า",
  formSelTitle: "เลือกคำนำหน้า",
  formSelProvince: "เลือกจังหวัด",
  formSelAmpur: "เลือกอำเภอ/เขต",
  formSelTumbon: "เลือกตำบล/แขวง",
  formSelZip: "เลือกรหัสไปรษณีย์",
  edit: "แก้ไข",
  editExpire: "หมดเขตการจองสิทธิไม่สามารถแก้ไขข้อมูลส่วนตัว",
  orderExpire: "หมดเขตการสั่งจองสินค้าแล้วค่ะ",
  agreeProfile: "ยอมรับและยืนยันตัวตน",
  clickToAgree:
    "หากกดปุ่มด้านล่างจะถือเป็นการยอมรับข้อกำหนด และเงื่อนไข กรุณาอ่าน",
  detaiHere: "รายละเอียดที่นี่",
  beforeEdit: "ก่อนเริ่มทำรายการ"
};
